export default {
  variation: {},
};
